import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { TransferService } from './transfer.service';
import { BranchStoreSelected } from '../../gestion/branch-stores/components/details/branch-store-details.component';
import { CartSaleService } from '../../point-of-sale/sales/components-aux/cart/cart-sale.service';
import { TFormatBoughtInCar } from '../../point-of-sale/sales/sales.interface';
import { BranchStoreBody, ProductsBody } from './transfer.interface';
export type ITypeProduct = 'REGULATED' | 'UNREGULATED';
export type ITypeProductId = 1 | 2;
export const TYPE_PRODUCT = {
  REGULATED: 1,
  UNREGULATED: 2
};
@Component({
  selector: 'pg-transfer',
  templateUrl: './transfer.component.html'
})
export class TransferComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  branchStoreOriginSelected = new BranchStoreSelected('Sucursal Origen');
  branchStoreDestineSelected = new BranchStoreSelected('Sucursal Destino');

  constructor(
    private fb: FormBuilder,
    private stockService: TransferService,
    private cartTransferService: CartSaleService
  ) {
    super('', stockService);
  }

  ngOnInit() {
    this.fg = this.fb.group({});
  }

  async onSubmit() {
    const documentPayload: BranchStoreBody = {
      branchStoreId: this.branchStoreOriginSelected.getId(),
      branchStoreReceptionId: this.branchStoreDestineSelected.getId()
    };

    const productsPayload: ProductsBody[] = this.buildProductsBody();
    const payload = {
      document: {
        ...documentPayload
      },
      products: [...productsPayload]
    };
    this.message = { message: 'Registrando traslado' };
    this.message = await this.stockService.register(payload);
    const status = this.message.status;
    if (status === 201) {
      setTimeout(() => {
        this.message = null;
        location.reload();
      }, 1500);
    }
  }

  buildProductsBody(): ProductsBody[] {
    const cartData = this.cartTransferService.getData();

    const productsBoughtBody = cartData.map((stockProductBought) => {
      const formatsBought = stockProductBought.formatsSelled;
      const formatsBody = {};

      for (const [format, formatData] of Object.entries(formatsBought)) {
        const typedFormatData = formatData as TFormatBoughtInCar;

        if (typedFormatData) {
          formatsBody[format] = {
            cantidad: typedFormatData.quantityInCart
          };
        }
      }

      return {
        productId: stockProductBought.productId,
        typeProductId: stockProductBought.typeProductId,
        codeProduct: stockProductBought.productCode.toString(),
        lot: stockProductBought.lot,
        description: stockProductBought.productName,
        expAt: stockProductBought.expAt,
        formats: { ...formatsBody }
      };
    });

    return productsBoughtBody;
  }

  isCartEmpty() {
    return this.cartTransferService.isCartEmpty();
  }

  ngOnDestroy() {
    this.cartTransferService.emptyData();
  }

  areBranchStoresSelected() {
    return (
      this.branchStoreOriginSelected.getId() !== undefined &&
      this.branchStoreDestineSelected.getId() !== undefined
    );
  }

  areBranchStoresDiferent() {
    return (
      this.branchStoreOriginSelected.getId() !==
      this.branchStoreDestineSelected.getId()
    );
  }
}
